const LoadingIcon = () => (
  <div className="fixed inset-0 flex items-center justify-center">
    <div className="spinner-border animate-spin border-4 border-orange-400 border-t-transparent w-12 h-12 rounded-full"></div>
  </div>
);

export default LoadingIcon;
